const getUpdatedSortProperties = (sort, sortby, sortProperties = []) => {
  const updatedSortProperties = [...sortProperties];
  if (!updatedSortProperties.length && sort) {
    updatedSortProperties.unshift({
      sort,
      propsToDisplay: sortby
    });
  }
  const sortbyFilters = updatedSortProperties.map(({
    propsToDisplay
  }) => propsToDisplay).filter(Boolean).flat();
  return [updatedSortProperties, sortbyFilters];
};
export default getUpdatedSortProperties;
//# sourceMappingURL=get-updated-sort-properties.js.map